/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	OrgOrganizationsDocsRetrievePathOrgId,
	OrgOrganizationsDocsRetrieveQueryOrgUnit,
	OrgOrganizationsDocsRetrieveStatus200,
} from "../types/OrgOrganizationsDocsRetrieve.ts";
import type { QueryKey, QueryClient, UseQueryOptions, UseQueryReturnType } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { orgOrganizationsDocsRetrieve } from "../requests/orgOrganizationsDocsRetrieve.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const orgOrganizationsDocsRetrieveQueryKey = (
	org_id?: MaybeRefOrGetter<OrgOrganizationsDocsRetrievePathOrgId>,
	params?: MaybeRefOrGetter<{ org_unit?: OrgOrganizationsDocsRetrieveQueryOrgUnit }>,
) => [{ url: "/api/org/organizations/:org_id/docs/", params: { org_id: org_id } }, ...(params ? [params] : [])] as const;

export type OrgOrganizationsDocsRetrieveQueryKey = ReturnType<typeof orgOrganizationsDocsRetrieveQueryKey>;

export function orgOrganizationsDocsRetrieveQueryOptions(
	org_id?: MaybeRefOrGetter<OrgOrganizationsDocsRetrievePathOrgId>,
	params?: MaybeRefOrGetter<{ org_unit?: OrgOrganizationsDocsRetrieveQueryOrgUnit }>,
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const queryKey = orgOrganizationsDocsRetrieveQueryKey(org_id, params);
	return queryOptions<OrgOrganizationsDocsRetrieveStatus200, ResponseErrorConfig<Error>, OrgOrganizationsDocsRetrieveStatus200>({
		enabled: () => !!toValue(org_id),
		queryKey,
		queryFn: async ({ signal }) => {
			return orgOrganizationsDocsRetrieve(toValue(org_id!), toValue(params), { ...config, signal: config.signal ?? signal });
		},
	});
}

/**
 * {@link /api/org/organizations/:org_id/docs/}
 */
export function useOrgOrganizationsDocsRetrieve<
	TData = OrgOrganizationsDocsRetrieveStatus200,
	TQueryData = OrgOrganizationsDocsRetrieveStatus200,
	TQueryKey extends QueryKey = OrgOrganizationsDocsRetrieveQueryKey,
>(
	org_id?: MaybeRefOrGetter<OrgOrganizationsDocsRetrievePathOrgId>,
	params?: MaybeRefOrGetter<{ org_unit?: OrgOrganizationsDocsRetrieveQueryOrgUnit }>,
	options: {
		query?: Partial<UseQueryOptions<OrgOrganizationsDocsRetrieveStatus200, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
			client?: QueryClient;
		};
		client?: Partial<RequestConfig> & { client?: Client };
	} = {},
) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey =
		(resolvedOptions && "queryKey" in resolvedOptions ? toValue(resolvedOptions.queryKey) : undefined) ?? orgOrganizationsDocsRetrieveQueryKey(org_id, params);

	const query = useQuery(
		{
			...orgOrganizationsDocsRetrieveQueryOptions(org_id, params, config),
			...resolvedOptions,
			queryKey,
		} as unknown as UseQueryOptions<OrgOrganizationsDocsRetrieveStatus200, ResponseErrorConfig<Error>, TData, OrgOrganizationsDocsRetrieveStatus200, TQueryKey>,
		toValue(queryClient),
	) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

	query.queryKey = queryKey as TQueryKey;

	return query;
}
